var _path, _path2, _path3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSystemSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 2151,
    viewBox: "0 0 1440 4151",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-377.284 1368.44C-346.442 1502.52 -209.282 1591.29 -12.1587 1626.29C184.929 1661.28 441.792 1642.48 711.706 1561.55C981.62 1480.62 1213.43 1352.91 1370.03 1211.88C1526.65 1070.81 1607.9 916.552 1577.06 782.478C1546.22 648.404 1409.06 559.628 1211.93 524.63C1014.85 489.638 757.982 508.446 488.068 589.373C218.154 670.301 -13.6572 798.011 -170.252 939.047C-326.875 1080.11 -408.126 1234.37 -377.284 1368.44Z",
    stroke: "url(#paint0_linear_880_458)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-748.132 1479.63C-705.565 1664.68 -516.282 1787.15 -244.366 1835.43C27.5155 1883.7 381.843 1857.75 754.163 1746.12C1126.48 1634.49 1446.25 1458.32 1662.28 1263.76C1878.32 1069.18 1990.47 856.33 1947.9 671.288C1905.34 486.246 1716.05 363.773 1444.14 315.496C1172.26 267.225 817.929 293.172 445.609 404.804C73.2883 516.436 -246.483 692.602 -462.504 887.16C-678.553 1081.74 -790.699 1294.59 -748.132 1479.63Z",
    stroke: "url(#paint1_linear_880_458)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M430.946 1549.62C169.745 1433.33 51.7926 1128.39 167.492 868.526C283.191 608.662 588.729 492.275 849.93 608.569C1111.13 724.863 1229.08 1029.8 1113.38 1289.66C997.685 1549.53 692.147 1665.92 430.946 1549.62Z",
    fill: "url(#paint2_linear_880_458)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_880_458",
    x1: 1508.55,
    y1: 744.374,
    x2: -244.433,
    y2: 1396.03,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#484848"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.491388,
    stopColor: "#484848",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#484848"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_880_458",
    x1: 1853.22,
    y1: 618.785,
    x2: -564.706,
    y2: 1517.63,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#484848"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.491388,
    stopColor: "#484848",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#484848"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_880_458",
    x1: 1581.28,
    y1: 775.643,
    x2: 685.513,
    y2: 1118.53,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.869792,
    stopColor: "white",
    stopOpacity: 0.151042
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#61B1FB",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSystemSmall);
export default __webpack_public_path__ + "static/media/systemSmall.e420612b1b8233f62b7bceb7bd697191.svg";
export { ForwardRef as ReactComponent };